import styles from "./SearchSampleTitleResults.module.scss";
import SampleListTitleResultCard from "./SampleListTitleResultCard.tsx";
import useSampleTitleResults from "../results/useSampleTitleResults.ts";
import MoreButton from "common/core-ui/MoreButton.tsx";

interface SearchSampleTitleResultsProps {
  sampleResults: ReturnType<typeof useSampleTitleResults>;
}

export default function SearchSampleTitleResults({
  sampleResults,
}: SearchSampleTitleResultsProps) {
  const { items, hasMore, loadMore, isLoadingMore, listRef, programName } =
    sampleResults;

  if (items.length === 0) {
    return null;
  }

  return (
    <div>
      <ul className={styles.allTitles} ref={listRef}>
        {items.map((asset, index) => (
          <SampleListTitleResultCard
            asset={asset}
            lazyLoad={index > 20}
            key={asset.vbid}
            programName={programName}
          />
        ))}
      </ul>

      {hasMore && (
        <MoreButton
          loading={isLoadingMore}
          hasMore={hasMore}
          wrapped
          onMoreClick={loadMore}
        />
      )}
    </div>
  );
}
